<template>
  <div>
    <h3 class="title">{{ $t(title) }}</h3>
    <span class="line"></span>
    <p class="desc">
      <span v-if="!showCount">{{ $t(desc) }}</span>
      <span v-if="showCount">{{ $t(descAgain) }}</span>

      <span class="tryAgainBtn" v-show="tryAgainBtn.show" @click="handleSendCode">
        {{ $t(tryAgainBtn.title) }}
      </span>

      <span class="count" v-show="showCount">
        {{ currentCount }}
      </span>
      <span v-show="showCount"> {{ $t('components-reset-pwd-unit') }}. </span>
    </p>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';

  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      desc: {
        type: String,
        default: '',
      },
      descAgain: {
        type: String,
        default: '',
      },
      tryAgainBtn: {
        type: Object,
        default: () => {},
      },
      sendData: {
        type: Object,
        default: () => {},
      },
      clearAllTimer: {
        type: Boolean,
        default: false,
      },
    },

    watch: {
      clearAllTimer(newval) {
        if (newval) {
          // 当前已经跳转到下一个页面了
          clearInterval(this.timer);
          this.timer = null;
          this.tryAgainBtn.show = false;
          this.showCount = false;
        }
      },
    },

    data() {
      return {
        currentCount: 0,
        timer: null,
        count: 60,
        showCount: false,
      };
    },

    methods: {
      getCode() {
        if (this.timer) clearInterval(this.timer);
        const time = this.count;
        if (!this.timer) {
          // 倒计时是否展示
          this.showCount = true;
          // tryAgain按钮是否展示
          this.tryAgainBtn.show = false;

          this.currentCount = time;
          this.timer = setInterval(() => {
            if (this.currentCount > 0 && this.currentCount <= time) {
              // eslint-disable-next-line no-plusplus
              this.currentCount--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.tryAgainBtn.show = true;
              this.showCount = false;
            }
          }, 1000);
        }
      },

      // 再次获取验证码
      handleSendCode() {
        this.$http.login.sendCode({ email: this.sendData.username }).then(res => {
          if (res.state === '11') {
            this.getCode();
          } else if (res.state === '00') {
            res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
          }
        });
      },

      ...mapMutations(['showMessageModal']),
    },
  };
</script>

<style lang="scss" scoped>
  @import './index';
  @import './mobile';
</style>
